import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const deleteResource = listeners["deleteResource"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      [
        "icon-delete",
        "删除",
        () => {
          deleteResource(item);
        },
        "leaderHome:delete",
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const ExpireTime = ({ props: { vo } }) => {
    return <div domPropsInnerHTML={vo.row.expireTime}></div>;
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "资源名称",
      minWidth: "200",
      prop: "bizName",
      showOverflowTooltip: true
    },
    {
      label: "类型",
      prop: "bizTypeName",
      width: "80"
    },
    {
      label: "上线状态",
      prop: "onlineStatusName",
      width: "100"
    },
    {
      label: "上线时间",
      prop: "onlineDate",
      width: "150"
    },
    {
      label: "有效状态",
      prop: "expireStatusName",
      width: "100"
    },
    {
      label: "生效时间",
      prop: "expireTime",
      width: "160",
      render: (vo) => <ExpireTime vo={vo} />
    },
    {
      label: "配置时间",
      prop: "createDate",
      width: "150"
    },
    {
      label: "操作",
      fixed: "right",
      width: "100",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
